module.exports = __webpack_public_path__ + "img/service_icon5.f3a28d0a.png";